.Code {
  color: var(--color-default);
  white-space: pre;
}

.LineNumber {
  color: var(--token-comment-color);
  border-right: 1px solid var(--color-panel-background);
  display: inline-block;
  padding-right: 1ch;
  margin-right: 1ch;
  min-width: calc(var(--max-line-number-length) + 1ch + 1px);
  user-select: none;
}

.Loader {
  background-color: var(--color-background-code);
  color: var(--color-default);
  display: inline-flex;
  align-items: center;
  gap: 1ch;
  border-radius: 0.5rem;
  padding: 0.25rem 0.5rem;
}
